import { useState, useContext, useEffect } from "react";
import moment from "moment";
import { RadioGroup } from "@headlessui/react";
import { Check } from "lucide-react";
import { calcularFechas } from "../credits/calculoFechas";
import { calcularTotalCuotaSimulador } from "../../utils/calcularTotalCuotaSimulador";
import { OfertaViewContext } from "../../context/OfertaContext/OfertaViewContext";
import { getInterest } from "../../utils/creditUser/getInterest";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const fechasOptions = calcularFechas();

const dateLimit1 = fechasOptions.fecha1.format("DD/MM/YYYY");
const dateLimit2 = fechasOptions.fecha2.format("DD/MM/YYYY");
const vence1 = fechasOptions.fecha1.diff(moment(), "days");
const vence2 = fechasOptions.fecha2.diff(moment(), "days");

const datepay = [
  {
    id: 1,
    datelimit: dateLimit1,
    expira: `Vence en ${vence1 + 1} días`,
  },
  {
    id: 2,
    datelimit: dateLimit2,
    expira: `Vence en ${vence2 + 1} días`,
  },
];

export function FechasRadioGroup({
  amount = 200000,
  creditUser,
  updateCreditUser,
  onSelectDate, // prop para devolver la fecha seleccionada
}) {
  const { updateOfertaView } = useContext(OfertaViewContext);
  const [selectedMailingLists, setSelectedMailingLists] = useState(null);
  const [tasa, setTasa] = useState(localStorage.getItem("currentInterestRate"));
  const admon = 60000;

  useEffect(() => {
    const cargarTasa = async () => {
      await getInterest();
      setTasa(localStorage.getItem("currentInterestRate"));
    };
    if (!tasa) cargarTasa();
  }, [tasa]);

  const handleChangeOption = (datePay) => {
    // 🔹 Actualiza selección visual
    setSelectedMailingLists(datePay);

    const dateSelected = moment(datePay.datelimit, "DD/MM/YYYY");
    const vencimientoEnDias = dateSelected.diff(moment(), "days") + 1;

    const total = calcularTotalCuotaSimulador({
      vencimientoEnDias,
      Amount: amount,
      admon,
      tasa,
    });

    // 🔹 Actualiza contexto global
    updateOfertaView({
      credit_id: creditUser.credit_id,
      approvedQuota: creditUser.approvedQuota,
      termInDays: vencimientoEnDias,
      totalToPay: total,
      paydayLimit: datePay.datelimit,
      documento: creditUser?.documento || localStorage.getItem("doc"),
      approvedDate: creditUser.approvedDate,
    });

    // 🔹 Notifica al componente padre
    if (onSelectDate) {
      onSelectDate(datePay.datelimit);
    }
  };

  useEffect(() => {
    // Preselecciona si viene del contexto o del usuario anterior
    if (creditUser?.paydayLimit) {
      const found = datepay.find((d) => d.datelimit === creditUser.paydayLimit);
      if (found) setSelectedMailingLists(found);
    }
  }, [creditUser?.paydayLimit]);

  return (
    <RadioGroup value={selectedMailingLists} onChange={setSelectedMailingLists}>
      <div className="mt-0 flex flex-col space-y-3 w-full gap-6">
        {datepay.map((datePay) => {
          const isSelected = selectedMailingLists?.id === datePay.id;

          return (
            <button
              key={datePay.id}
              type="button"
              onClick={() => handleChangeOption(datePay)}
              name="fechaLimite"
              className={classNames(
                "w-full flex justify-between items-center px-4 py-3 border border-gray-300 text-gray-400 transition-all"
              )}
              style={{
                height: "60px",
                borderRadius: "2.5rem",
                backgroundColor: isSelected ? "#565584" : "#2C2447",
                color: isSelected ? "#C9B8FF" : "#BEBCC2",
                border: isSelected ? "1px solid #C9B8FF" : "none",
                cursor: "pointer",
              }}
            >
              <div className="flex flex-row items-center gap-4">
                <span
                  className="text-xl"
                  style={{ fontWeight: "400", fontFamily: "GT Walsheim Pro" }}
                >
                  {datePay.datelimit}
                </span>
              </div>

              <Check
                className={`w-7 h-7`}
                style={{
                  color: isSelected ? "#C9B8FF" : "#BEBCC2",
                }}
                strokeWidth={2.5}
              />
            </button>
          );
        })}
      </div>
    </RadioGroup>
  );
}
